'use client';

import { usePageAction } from '@repo/hooks/usePageAction';
import { css } from '@repo/pandacss/styled-system/css';
import { MarketplaceProductTypeEnum } from '@repo/supergraph/marketplace/constants';
import { SafeLinkWithFallback } from '../SafeLinkWithFallback';

type Props = {
  recapDescription?: string;
  reviewLink?: string;
  displayName?: string;
  id: string;
};

export const RecapListItem = ({ recapDescription, reviewLink, displayName, id }: Props) => {
  if (!displayName) return null;

  const fireEventAction = usePageAction({
    actionName: 'nw_review_redirected',
    actionSection: MarketplaceProductTypeEnum.Banking.toLowerCase(),
    actionType: 'select',
  });

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const targetLink = event.currentTarget.getAttribute('href');
    fireEventAction({
      ...(targetLink && { action_destination_url: targetLink }),
    });
  };

  return (
    <li
      key={`recap-list-item-${id}`}
      className={css({
        paddingBlockStart: '1',
        paddingBlockEnd: '1',
        paddingInlineStart: '0',
        paddingInlineEnd: '0',
      })}
    >
      <SafeLinkWithFallback href={reviewLink} onClick={handleClick}>
        {displayName}
      </SafeLinkWithFallback>
      {recapDescription && `: ${recapDescription}`}
    </li>
  );
};
